import React from 'react';
import { Button } from 'react-bootstrap';
import './SuccessButton.css';

const SuccessButton = ({
  children,
  onClick,
  disabled = false,
  variant = 'success',
  size = '',
  className = '',
  // Dynamic styling props with defaults
  width = 'fit-content',
  mobileWidth = null, // Width for mobile devices (< 768px)
  height = 'auto',
  padding = '0.6rem 1.2rem',
  fontSize = '14px',
  fontWeight = '600',
  borderRadius = 'var(--radius-sm)',
  backgroundColor = 'var(--success)',
  borderColor = 'var(--success)',
  color = 'white',
  hoverBackgroundColor = 'var(--success-hover)',
  hoverBorderColor = 'var(--success-hover)',
  hoverColor = 'white',
  boxShadow = 'none',
  hoverBoxShadow = '0 4px 8px rgba(var(--success-rgb), 0.2)',
  transform = 'none',
  hoverTransform = '',
  transition = 'none',
  ...props
}) => {
  const dynamicStyle = {
    width,
    height,
    padding,
    fontSize,
    fontWeight,
    borderRadius,
    backgroundColor,
    borderColor,
    color,
    boxShadow,
    transform,
    transition,
    // CSS custom properties for hover states
    '--hover-bg': hoverBackgroundColor,
    '--hover-border': hoverBorderColor,
    '--hover-color': hoverColor,
    '--hover-shadow': hoverBoxShadow,
    '--hover-transform': hoverTransform,
    // Mobile width
    '--mobile-width': mobileWidth || width,
    ...props.style
  };

  return (
    <Button
      className={`success-btn ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      style={dynamicStyle}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SuccessButton;